import React, {memo} from "react";
// import Swiper core and required components
import SwiperCore, {Navigation, Scrollbar, A11y} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';

import {useDispatch, useSelector} from "react-redux";
import {
    actionChangeActiveDayPostSchedule,
    actionChangeActiveSelectTablePostSchedule
} from "../../../../../../redux/actions/modals/modalShoppingCard";
import _ from "lodash";


// install Swiper components
SwiperCore.use([Navigation, Scrollbar, A11y]);
const PostScheduleBody = () => {

    const dispatch = useDispatch();
    const {days, activeDayPostSchedule, activeSelectTablePostSchedule} = useSelector(state => state.modalShoppingCard);

    const onClickItemDay = (key) => {
        dispatch(actionChangeActiveDayPostSchedule(key));
    };

    const handelOnClickSelectTime = (time) => {
        if (time.selectable)
            dispatch(actionChangeActiveSelectTablePostSchedule(time));
    };

    const settingSwiper = {
        freeMode: true,
        spaceBetween: 5,
        breakpoints: {
            0: {slidesPerView: 3.5}
        }
    }

    return days.days && (
        <React.Fragment>
            <div className={'mt-2'}>
                <div className={'swiper-day-modal-select-time'} dir={"ltr"}>
                    {_.size(days.days) > 0 &&
                    <Swiper {...settingSwiper}>
                        {_.map(days.days, (day, key) =>
                            <SwiperSlide key={key}>
                                <div
                                    className={`card-item-day-show-send ${activeDayPostSchedule === key ? 'select' : ''}`}
                                    onClick={() => onClickItemDay(key)}
                                >
                                    <div>
                                        <span>{day.title}</span>
                                    </div>
                                    <div>
                                        <span>{day.shamsi}</span>
                                    </div>
                                </div>
                            </SwiperSlide>
                        )}
                    </Swiper>
                    }
                </div>
                <ul className={'box-times-send-modal-select-time'}>
                    {/*{((typeof days.days !== "undefined" && Object.keys(days.days).length) > 0) &&
                    Object.keys(days.days).map((key) => {
                        if (key === activeDayPostSchedule) {
                            return days.days[key].times.map((time, indexTime) => {
                                return (
                                    <li key={indexTime} onClick={() => handelOnClickSelectTime(time)}>
                                        <div
                                            className={`item-times-send-modal-select-time ${time.selectable ? '' : 'disabled-time'}
                                                ${(Object.keys(activeSelectTablePostSchedule).length > 0 && activeSelectTablePostSchedule.id === time.id) ? 'select' : ''}`}>
                                            <div>
                                                <span>{time.cost}</span>
                                            </div>
                                            <div>
                                                <span>{time.time}</span>
                                                <div className={'border-checked-box-item-send-modal-select-time'}>
                                                    <div
                                                        className={'body-checked-box-item-send-modal-select-time'}/>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                );
                            });
                        } else return '';
                    })
                    }*/}
                    {
                        _(days.days).find((day, key) => key === activeDayPostSchedule).times.map(time => (
                            <li key={time.id} onClick={() => handelOnClickSelectTime(time)}>
                                <div
                                    className={`item-times-send-modal-select-time ${time.selectable ? '' : 'disabled-time'} ${(_.size(activeSelectTablePostSchedule) && activeSelectTablePostSchedule.id === time.id) ? 'select' : ''}`}>
                                    <div>
                                        <span>{time.cost}</span>
                                    </div>
                                    <div>
                                        <span>{time.time}</span>
                                        <div className={'border-checked-box-item-send-modal-select-time'}>
                                            <div className={'body-checked-box-item-send-modal-select-time'}/>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        ))
                    }
                </ul>
            </div>
        </React.Fragment>
    );
};

export default memo(PostScheduleBody);
